import { render, staticRenderFns } from "./ClinicIdModal.vue?vue&type=template&id=38c9584c&scoped=true&"
import script from "./ClinicIdModal.vue?vue&type=script&lang=js&"
export * from "./ClinicIdModal.vue?vue&type=script&lang=js&"
import style0 from "./ClinicIdModal.vue?vue&type=style&index=0&id=38c9584c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c9584c",
  null
  
)

component.options.__file = "ClinicIdModal.vue"
export default component.exports